import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";
import {BarbarianFury} from "../BarbarianFury";
import {BarbarianFuryGameModuleConfig} from "../BarbarianFuryGameModuleConfig";

export class BarbarianWinFieldController extends WinFieldController {

    public showWinField(to?: number, forceWin: boolean = false, forceTotalWin: boolean = false): void {
        if (this.shouldShow()) {
            to = to != null ? to : this._totalWin;
            const isWinBelow: boolean = BarbarianFuryGameModuleConfig.featurePrice.isWinBelowStake();

            if (!forceWin && (forceTotalWin || this._shouldShowTotalWin || this._shouldNextShowTotalWin)) {
                BarbarianFury.keypad.setWin(to, true, isWinBelow);
                return;
            }
            BarbarianFury.keypad.setWin(to, undefined, isWinBelow);
        }
    }
}